import { Routes, Route } from 'react-router-dom';

import { publicRoutes, protectedRoutes } from './allRoutes';

// Components
import ProtectedRoute from 'components/ProtectedRoute';

function AppRoutes() {
    return (
        <Routes>
                {/* Public Routes */}
                {
                    publicRoutes.map(route => {
                        return (
                            <Route key={route.name} path={route.path} element={route.element} />
                        )
                    })
                }

                {/* Protected Routes */}
                {
                    protectedRoutes.map(route => {
                        return (
                            <Route key={route.name} path={route.path} element={<ProtectedRoute>{route.element}</ProtectedRoute>} />
                        )
                    })
                }
            </Routes>
    );
}

export default AppRoutes;